import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import MakePostList from '@/views/MakePost/List'
import Preview from '@/views/MakePost/Preview'
import Page from '@/views/MakePost/Page'
import SecondPage from '@/views/MakePost/SecondPage'
import Advertise from '@/views/MakePost/Advertise'
import commonPage from '@/views/MakePost/commonPage'
Vue.use(Router)
export default new Router({
	routes: [{
		path: '/',
		name: 'MakePost',
		component: Home,
		children: [{
				path: 'List',
				name: '用户列表',
				component: MakePostList
			},
			{
				path: 'Preview',
				name: '预览页面',
				component: Preview
			},
			{
				path: 'Page',
				name: '广告页面',
				component: Page
			},
			{
				path: 'SecondPage',
				name: '常规广告',
				component: SecondPage
			},
			{
				path: 'Advertise',
				name: '编辑广告',
				component: Advertise
			},
			{
				path: 'commonPage',
				name: '常规广告页面',
				component: commonPage
			}
		],
		meta: {
			requireAuth: true //添加该字段，true表示进入这个路由是需要登录的,false不需要登录
		},
	}, ]
})


// WEBPACK FOOTER //
// ./src/router/index.js